import { ResourceOptions } from 'react-admin';
import { MdOutlineReceiptLong } from 'react-icons/md';

import { Resources } from '../../resource';

// One page serves both tabs: `/vault/records` opens Subscriptions and `/vault/records/:tab` a given tab (PRD §14.1,
// §14.6). react-admin mounts `edit` at `:id`; the page reads it as the tab with useParams and edits nothing.
export { default as list, default as edit } from './Records';
export { RECORDS_PERMISSION_RESOURCE } from './constants';

export const name = Resources.vaultRecords;
export const icon = MdOutlineReceiptLong;
export const options: ResourceOptions = {
  label: 'module.vaultRecords.title',
};
